import TableFunction from '../../../../../../../components/table/TableFunction';
import { VIEW_TYPE } from '../../../../../../../enums/ViewType';
import React, { useEffect, useState } from 'react';
import { SEARCH_MODEL } from '../../../../../../../components/table/Model/TableModel';
import { SimpleSearch } from '../../../../../../../reduxToolkit/Search/SearchApi';
import DropDownMenuProfile from '../../../../../../../components/DropDown/DropDownMenuProfile';
import { permissionObj } from '../../../../../../../Helpers/permission';
import DropDownMenuItem from '../../../../../../../components/DropDown/DropDownMenuItem';
import routes from '../../../../../../../Routes/routes';
import {
    DeleteIconsOptions,
    UpdateIconsOptions
} from '../../../../../../../components/buttons/IconButtons';
import { useDispatch, useSelector } from 'react-redux';
import { errorMsg } from '../../../../../../../Apis/functions';
import { ATTENDANCE_SUBVIEW_MODEL } from '../../../Model/Model';
import { DeleteItemsApi } from '../../../../../../../reduxToolkit/Commons/CommonsApi';
import {useNavigate} from 'react-router-dom';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const ShiftAccessApp = (
    {
        registerAction,
        option,
        selectForDelete,
        setSelectForDelete,
        searchElement,
        setSimpleSearch,
        view = VIEW_TYPE.LIST.name,
    }
) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const [searchResults, setSearchResults] = useState(null);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [modified, setModified] = useState(false);
    const [deleteModalShow, setDeleteModalShow] = useState(false);
    let searchId = 'txt_saa_search_shifts'

    const columns = [
        { field: 'name', label: 'schedule' }
    ];

    const handleDelete = () => {
        setDeleteModalShow(true);
    };

    const fnDelete = () => {
        if (selectForDelete.length > 0) {
            dispatch(DeleteItemsApi({ tableName: option, body: selectForDelete })).then(({ payload: { data: { success, code } } }) => {
                if (success === true) {
                    setModified(true);
                    setSelectForDelete([]);
                } else errorMsg(code);
            });
        }
    };

    useEffect(() => {
        registerAction(
            ATTENDANCE_SUBVIEW_MODEL.MANAGE.SHIFT_ACCESS,
            { handleDelete }
        );
    }, [selectForDelete]);

    const RenderOptionsMenu = (row) => {
        return (
            <>
                <DropDownMenuProfile
                    openMenu={openMenu}
                    handleMenuToggle={handleMenuToggle}
                    menuId={`menu-${row.id}`}
                    isAccordion={true}
                >
                    {(DEV || permission?.includes(permissionObj?.WEB_ATTENDANCE_SHIFT_UPDATE)) &&
                        <DropDownMenuItem
                            id={`btn_saa_edit_${row.id}`}
                            index={row.id}
                            handleClose={handleClose}
                            name={t('update')}
                            url={`${routes.attendanceShiftAccess.addEdit}${row.id}`}
                            icon={<UpdateIconsOptions />}
                        />
                    }

                    {(DEV || permission?.includes(permissionObj?.WEB_ATTENDANCE_SHIFT_DELETE)) &&
                        <DropDownMenuItem
                            id={`btn_saa_delete_${row.id}`}
                            index={row.id}
                            handleClose={handleClose}
                            name={t('delete')}
                            fontColor='font-color-error-600'
                            iconColor={"icon-color-error-code-600"}
                            click={() => {
                                setSelectForDelete([row.id])
                                handleDelete();
                            }}
                            icon={<DeleteIconsOptions />}
                        />
                    }

                </DropDownMenuProfile>
            </>
        )
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = page => {
        const body = SEARCH_MODEL.setObject({ page: page, size: rowsPerPage, model: option, key: searchElement, view: view });
        dispatch(SimpleSearch({ body })).then(({ payload: { data: { data, success } } }) => {
                if (success === true) {
                    setSearchResults(data);
                }
            }
        );
    }

    const { t, handleCheckboxChange, handleDeleteAll,
        pagination, page, rowsPerPage,
        handleRowExpand,
        handleMenuToggle,
        handleClose,
        openMenu
    } = TableFunction({
        selectedList: selectForDelete,
        setSelectedList: setSelectForDelete,
        data: searchResults,
        view: view,
        labelRowsPerPage: 'shifts_per_page',
        fixedPagination: false,
        hasContainer: true,
        setIsAllChecked,
        searchElement, //New
        getData,//New
        modified,//New
        setModified//New
    });

    return {
        t,
        DEV, permission,navigate,
        searchId,
        deleteModalShow, setDeleteModalShow,
        searchResults, setSearchResults,
        page, rowsPerPage,
        handleRowExpand,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        columns,
        RenderOptionsMenu,
        fnDelete
    }
}

export default ShiftAccessApp
